import React from 'react';

const TagReviewBulletItem = (props) => {
    const { title, value, makeTitleStrong = false } = props;
    if (makeTitleStrong) {
        return (
            <>
                <strong>{title}:</strong> {value}
            </>
        );
    } else {
        return (
            <>
                {title}: <strong>{value}</strong>
            </>
        );
    }

};

// default props
TagReviewBulletItem.defaultProps = {};
// validate props
TagReviewBulletItem.propTypes = {};

export default TagReviewBulletItem;
